/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BloodManagementStartAliases {
  BLOOD_LEGENDS_START = 'blood-legends-start',
  BLOOD_START_ACCORDION = 'blood-start-accordion',
  BLOOD_START_ACCORDION_PANEL = 'blood-start-accordion-panel',
  BLOOD_START_ACCORDION_PLUS_TITLE_PANEL = 'blood-start-accordion-plus-title-panel',
  BLOOD_START_ACCORDION_PLUS_TITLE_TEXT = 'blood-start-accordion-plus-title-text',
  BLOOD_START_ACCORDION_TITLE_PANEL = 'blood-start-accordion-title-panel',
  BLOOD_START_ACCORDION_TITLE_TEXT = 'blood-start-accordion-title-text',
  BLOOD_START_BARCODE = 'blood-start-barcode',
  BLOOD_START_BARCODE_BAG = 'blood-start-barcode-bag',
  BLOOD_START_BARCODE_PANEL = 'blood-start-barcode-panel',
  BLOOD_START_BARCODE_PANEL_BAG = 'blood-start-barcode-panel-bag',
  BLOOD_START_BUTTON = 'blood-start-button',
  BLOOD_START_BUTTON_PANEL_PADDING = 'blood-start-button-panel-padding',
  BLOOD_START_CARD = 'blood-start-card',
  BLOOD_START_CARD_DECK = 'blood-start-card-deck',
  BLOOD_START_CARD_PANEL = 'blood-start-card-panel',
  BLOOD_START_CARDS_ACCORDION = 'blood-start-cards-accordion',
  BLOOD_START_CARDS_ACCORDION_PANEL = 'blood-start-cards-accordion-panel',
  BLOOD_START_CONTENT_PANEL = 'blood-start-content-panel',
  BLOOD_START_DATE_TIME_FIELD = 'blood-start-date-time-field',
  BLOOD_START_DATE_TIME_TEXT = 'blood-start-date-time-text',
  BLOOD_START_DEVICE_AUTOCOMPLETE = 'blood-start-device-autocomplete',
  BLOOD_START_DEVICE_FETCH = 'blood-start-device-fetch',
  BLOOD_START_DEVICE_FIELD = 'blood-start-device-field',
  BLOOD_START_DEVICE_MAPPER = 'blood-start-device-mapper',
  BLOOD_START_DEVICE_TEXT = 'blood-start-device-text',
  BLOOD_START_FORM = 'blood-start-form',
  BLOOD_START_INFUSION_FORM_AUTOCOMPLETE = 'blood-start-infusion-form-autocomplete',
  BLOOD_START_INFUSION_FORM_FETCH = 'blood-start-infusion-form-fetch',
  BLOOD_START_INFUSION_FORM_FIELD = 'blood-start-infusion-form-field',
  BLOOD_START_INFUSION_FORM_MAPPER = 'blood-start-infusion-form-mapper',
  BLOOD_START_INFUSION_FORM_TEXT = 'blood-start-infusion-form-text',
  BLOOD_START_INFUSION_SPEED_FIELD = 'blood-start-infusion-speed-field',
  BLOOD_START_INFUSION_SPEED_INPUT = 'blood-start-infusion-speed-input',
  BLOOD_START_LAYOUT = 'blood-start-layout',
  BLOOD_START_NAME_DATE_PANEL = 'blood-start-name-date-panel',
  BLOOD_START_NAME_FIELD = 'blood-start-name-field',
  BLOOD_START_NAME_TEXT = 'blood-start-name-text',
  BLOOD_START_NEW_DATE_FIELD = 'blood-start-new-date-field',
  BLOOD_START_NEW_DATE_INPUT = 'blood-start-new-date-input',
  BLOOD_START_UNITY_AUTOCOMPLETE = 'blood-start-unity-autocomplete',
  BLOOD_START_UNITY_FETCH = 'blood-start-unity-fetch',
  BLOOD_START_UNITY_FIELD = 'blood-start-unity-field',
  BLOOD_START_UNITY_MAPPER = 'blood-start-unity-mapper',
  BLOOD_START_UNITY_TEXT = 'blood-start-unity-text',
  BLOOD_START_VOLUME_STEP_FIELD = 'blood-start-volume-step-field',
  BLOOD_START_VOLUME_STEP_INPUT = 'blood-start-volume-step-input',
  GLOBAL_ACTIONS = 'global-actions',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
}
export { BloodManagementStartAliases };
